import { FC } from 'react'

import GoldenTexture from 'assets/golden-bg.webp'
import { IconShare } from 'components/icons/share2'
import { buildShareUrl } from './helpers'
import { Facebook } from './icons/facebook'
import { Instagram } from './icons/instagram'
import { Telegram } from './icons/telegram'
import { Twitter } from './icons/twitter'
import { VKontakte } from './icons/vkontakte'
import { YouTube } from './icons/youtube'
import { ShareContainer, TexturedText } from './styled'

const shareOptions = [
  {
    Component: Facebook,
    shareLink: buildShareUrl('facebook'),
    profileLink: 'https://www.facebook.com/currenttimetv',
  },
  {
    Component: VKontakte,
    shareLink: buildShareUrl('vk'),
    profileLink: 'https://vk.com/currenttimetv',
  },
  {
    Component: Telegram,
    shareLink: buildShareUrl('telegram'),
    profileLink: 'https://telegram.me/currenttime',
  },
  {
    Component: Twitter,
    shareLink: buildShareUrl('twitter'),
    profileLink: 'https://twitter.com/CurrentTimeTv',
  },
  {
    Component: YouTube,
    profileLink: 'https://www.youtube.com/user/currenttimetv',
  },
  {
    Component: Instagram,
    profileLink: 'https://www.instagram.com/currenttime.tv/',
  },
]

export const Share: FC<{ isShare?: boolean }> = ({ isShare }) => (
  <>
    <ShareContainer $spacing={isShare ? 'small' : 'large'}>
      <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'absolute' }}
      >
        <defs>
          <pattern id="golden-texture" width="100%" height="100%">
            <image href={GoldenTexture} y="-2" height="33" width="50" />
          </pattern>
        </defs>
      </svg>

      {(isShare ? shareOptions.filter(o => !!o.shareLink) : shareOptions).map(
        ({ Component, ...o }, i) => (
          // eslint-disable-next-line react/jsx-no-target-blank
          <a
            href={isShare ? o.shareLink : o.profileLink}
            target="_blank"
            key={i}
          >
            <Component isShare={isShare} />
          </a>
        )
      )}
    </ShareContainer>
    {isShare && (
      <TexturedText>
        <IconShare isTextured /> Поделись
      </TexturedText>
    )}
  </>
)
